import { setEndTime } from './chatFilterSetters';
const updateEndTime = (filters, value) => {
  return setEndTime(value, filters);
};
export default updateEndTime;